"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _invitationType = require("../../store/gift/invitationType/invitationType.selectors");

var _invitationType2 = require("../../store/gift/invitationType/invitationType.actions");

var _InvitationTypeListItem = _interopRequireDefault(require("./InvitationTypeListItem"));

var InvitationTypesList = function InvitationTypesList() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var invitationTypes = (0, _reactRedux.useSelector)(_invitationType.getAvailableInvitationTypes);
  var activeInvitationTypeId = (0, _reactRedux.useSelector)(_invitationType.getSelectedInvitationTypeId);
  var setActiveInvitationTypeCb = (0, _react.useCallback)(function (id) {
    dispatch((0, _invitationType2.selectInvitationTypeId)(id));
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignContent: "flex-start"
  }, invitationTypes.map(function (type) {
    return /*#__PURE__*/_react.default.createElement(_InvitationTypeListItem.default, {
      key: type.id,
      id: type.id,
      name: type.name,
      image: type.image,
      remaining: type.remaining,
      selected: activeInvitationTypeId === type.id,
      disabled: !type.allowedForCountry || !type.isAvailable,
      disabledTooltip: !type.allowedForCountry ? 'This gift invitation method is available in US & CAN only' : '',
      onClick: setActiveInvitationTypeCb,
      description: type.description
    });
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(InvitationTypesList);

exports.default = _default;